import { TierHostItineraries } from 'modules/host-onboarding/model/PotentialItineraries';
import req from 'utils/req';
import { HOST_STATUS } from '~/constants';

type CandidateProgress = {
  completed: boolean;
  progressData: {
    verifications: [
      {
        type: 'PhoneNumber';
        value: string;
      },
      {
        type: 'EmailAddress';
        value: string;
      },
    ];
    onboardingCourseStatus: 'NotStarted' | 'InProgress' | 'Completed';
    tierCoursesStatus: {
      [tier: string]: 'Pristine' | 'InProgress' | 'Completed';
    };
  };
};

export const HostCandidateQueryKeys = ['host', 'candidate'];

export async function getCandidateInfo(accountId: string): Promise<any> {
  if (!accountId) {
    return null;
  }
  return await req(
    `${URL_API_HOST}/api/v1/portfolio/host/onboarding/${accountId}`,
  )
    .get()
    .catch(() => ({ status: { type: HOST_STATUS.INITIAL } }));
}

export async function getCandidateProgress(
  accountId: string,
): Promise<CandidateProgress> {
  if (!accountId) {
    return undefined;
  }
  return req(
    `${URL_API_HOST}/api/v1/portfolio/host/onboarding/${accountId}/progress`,
  )
    .get()
    .catch(() => null);
}

export async function setCourseCompleted(accountId: string, courseId: string) {
  return req(
    `${URL_API_HOST}/api/v1/portfolio/host/onboarding/${accountId}/tier-course`,
  ).put({ courseId });
}

export async function getPotentialItineraries(
  accountId: string,
): Promise<TierHostItineraries[]> {
  if (!accountId) {
    return null;
  }
  return req(
    `${URL_API_HOST}/api/v1/portfolio/host/${accountId}/potential-itineraries`,
  )
    .get()
    .catch(() => null);
}
